module.exports = "img/videos/12.50ce4b.mp4";